import { useContext, createContext } from 'react';

export const DisclosureContext = createContext<{
  open?: boolean;
  large: boolean;
  fill: boolean;
}>({
  open: false,
  large: false,
  fill: false,
});

export default function useDisclosureContext() {
  const context = useContext(DisclosureContext);
  if (!context) {
    throw new Error(
      'Disclosure compound components cannot be rendered outside the Disclosure component',
    );
  }
  return context;
}
